import { render } from "./GroupComparison.vue?vue&type=template&id=25c7dbf9&scoped=true"
import script from "./GroupComparison.vue?vue&type=script&lang=js"
export * from "./GroupComparison.vue?vue&type=script&lang=js"

import "./GroupComparison.vue?vue&type=style&index=0&id=25c7dbf9&lang=scss&scoped=true"
import "./GroupComparison.vue?vue&type=style&index=1&id=25c7dbf9&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25c7dbf9"]])

export default __exports__